import { get } from "./api";
import URLS from "../constants/api";

export const getAllEvents = async (
) => {

  const response = await get(URLS.GET_ALL_EVENTS);
  return response;
};
